var exports = {
  "N1": "ChannelHeader.module__headerContainer___dnJmYn",
  "dL": "ChannelHeader.module__headerWrapper___dnJmYn",
  "Hv": "ChannelHeader.module__headerWrapperCallActive___dnJmYn",
  "hE": "ChannelHeader.module__headerContainerCallActive___dnJmYn",
  "Ud": "ChannelHeader.module__headerLeftSection___dnJmYn",
  "Gv": "ChannelHeader.module__backButton___dnJmYn",
  "wK": "ChannelHeader.module__backButtonDesktop___dnJmYn" + " " + "ChannelHeader.module__backButton___dnJmYn",
  "j2": "ChannelHeader.module__backIcon___dnJmYn",
  "Ir": "ChannelHeader.module__backIconBold___dnJmYn" + " " + "ChannelHeader.module__backIcon___dnJmYn",
  "CY": "ChannelHeader.module__leftContentContainer___dnJmYn",
  "Bn": "ChannelHeader.module__voiceCallHeaderSupplement___dnJmYn",
  "BN": "ChannelHeader.module__mobileButton___dnJmYn",
  "Vt": "ChannelHeader.module__desktopButton___dnJmYn" + " " + "ChannelHeader.module__mobileButton___dnJmYn",
  "R3": "ChannelHeader.module__avatarWrapper___dnJmYn",
  "ax": "ChannelHeader.module__groupDmHeaderTrigger___dnJmYn",
  "_D": "ChannelHeader.module__groupDmHeaderInner___dnJmYn",
  "ab": "ChannelHeader.module__groupDmEditIcon___dnJmYn",
  "HA": "ChannelHeader.module__channelName___dnJmYn",
  "$7": "ChannelHeader.module__groupDmChannelName___dnJmYn",
  "kf": "ChannelHeader.module__dmNameWrapper___dnJmYn",
  "a1": "ChannelHeader.module__userTag___dnJmYn",
  "p": "ChannelHeader.module__channelIcon___dnJmYn",
  "ml": "ChannelHeader.module__caretRight___dnJmYn",
  "Nj": "ChannelHeader.module__channelInfoContainer___dnJmYn",
  "u8": "ChannelHeader.module__followButton___dnJmYn",
  "B6": "ChannelHeader.module__topicDivider___dnJmYn",
  "zm": "ChannelHeader.module__topicContainer___dnJmYn",
  "yu": "ChannelHeader.module__topicButton___dnJmYn",
  "Am": "ChannelHeader.module__topicButtonOverflow___dnJmYn",
  "lY": "ChannelHeader.module__headerRightSection___dnJmYn",
  "P0": "ChannelHeader.module__messageSearchFocusWrapper___dnJmYn",
  "bS": "ChannelHeader.module__headerContainerThreadPanelOpen___dnJmYn",
  "gb": "ChannelHeader.module__iconButton___dnJmYn",
  "f5": "ChannelHeader.module__iconButtonDefault___dnJmYn" + " " + "ChannelHeader.module__iconButton___dnJmYn",
  "vR": "ChannelHeader.module__iconButtonSelected___dnJmYn" + " " + "ChannelHeader.module__iconButton___dnJmYn",
  "rB": "ChannelHeader.module__updateIconButton___dnJmYn" + " " + "ChannelHeader.module__iconButton___dnJmYn",
  "l_": "ChannelHeader.module__updateIcon___dnJmYn",
  "IC": "ChannelHeader.module__iconButtonMobile___dnJmYn",
  "iA": "ChannelHeader.module__buttonIcon___dnJmYn",
  "qt": "ChannelHeader.module__buttonIconMobile___dnJmYn",
  "Dm": "ChannelHeader.module__iconButtonWrapper___dnJmYn",
  "W9": "ChannelHeader.module__unreadPinIndicator___dnJmYn",
};

module.exports = exports;
